import { render, staticRenderFns } from "./XhDate.vue?vue&type=template&id=c8064d10&scoped=true"
import script from "./XhDate.vue?vue&type=script&lang=js"
export * from "./XhDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8064d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8064d10')) {
      api.createRecord('c8064d10', component.options)
    } else {
      api.reload('c8064d10', component.options)
    }
    module.hot.accept("./XhDate.vue?vue&type=template&id=c8064d10&scoped=true", function () {
      api.rerender('c8064d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhDate.vue"
export default component.exports